import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { wrapper } from 'store';

import { setAdvertiserProfile } from 'features/advertiserProfileSlice';
import axios from 'utils/axios';
import useScrollToTop from 'hooks/useScrollToTop';
import AdvertiserProfile from 'components/advertiserProfile/AdvertiserProfile';
import DocumentHead from 'components/DocumentHead';

const AdvertiserProfilePage = () => {
  const [profile, setProfile] = useState(null);

  const router = useRouter();
  const { username } = router.query;
  const profileStore = useSelector(state => state.advertiserProfile.profile);

  useScrollToTop();

  useEffect(() => {
    if (!profileStore) return;

    if (profileStore.username === username) {
      setProfile(profileStore);
    }
  }, [profileStore, username]);

  if (!profile) return null;

  return (
    <>
      <DocumentHead>
        <title>{profile.display_name} | GigSocial</title>
        <meta property="og:title" content={`${profile.display_name} | GigSocial`} key="og:title" />

        {profile.avatar_url && (
          <>
            <meta property="og:image" content={profile.avatar_url} key="og:image" />
            <meta name="twitter:image" content={profile.avatar_url} key="twitter:image" />
          </>
        )}

        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_URL}/c/${profile?.username}`}
          key="og:url"
        />

        <meta
          property="twitter:url"
          content={`${process.env.NEXT_PUBLIC_URL}/c/${profile?.username}`}
          key="twitter:url"
        />
      </DocumentHead>

      <AdvertiserProfile profile={profile} />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(store => async context => {
  const { params } = context;
  const { username } = params;

  try {
    const response = await axios.get(`/v1/users/${username}/profile`);
    store.dispatch(setAdvertiserProfile(response.data));
  } catch (error) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }
});

export default AdvertiserProfilePage;
